import { useState } from "react";
import { login } from "../lib/api";

export const LoginModal = ({ open, onClose, onSuccess }) => {
  const [pin, setPin] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  if (!open) return null;

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const data = await login(pin);
      setLoading(false);
      if (data.valid) {
        setPin("");
        onSuccess(data);
      } else {
        setError("PIN salah. Hubungi admin bila lupa PIN.");
      }
    } catch {
      setLoading(false);
      setError("Gagal terhubung ke server.");
    }
  };

  return (
    <div
      className="fixed inset-0 z-[60] bg-slate-900/70 backdrop-blur-sm flex items-center justify-center p-4 animate-fade-up"
      onMouseDown={(e) => e.target === e.currentTarget && onClose()}
    >
      <form onSubmit={submit} className="bg-white rounded-2xl shadow-2xl w-full max-w-sm p-6 space-y-4" data-testid="login-modal">
        <div className="text-center">
          <div className="inline-flex p-3 bg-teal-100 text-teal-700 rounded-full mb-2">
            <i className="ph-bold ph-lock-key text-2xl" />
          </div>
          <h3 className="text-lg font-bold text-slate-800">Masuk untuk Lihat Data</h3>
          <p className="text-xs text-slate-500 mt-1">
            Admin: akses penuh. Pelanggan: masukkan PIN lokasi Anda untuk melihat riwayat pekerjaan.
          </p>
        </div>
        <input
          type="password" inputMode="text" autoFocus value={pin}
          onChange={(e) => setPin(e.target.value)} placeholder="Masukkan PIN..."
          className="w-full px-3 py-2.5 border border-slate-300 rounded-lg text-sm text-center tracking-[0.4em] font-bold focus:ring-2 focus:ring-teal-500 outline-none"
          data-testid="login-pin-input"
        />
        {error && <p className="text-xs text-red-500 font-medium text-center" data-testid="login-error">{error}</p>}
        <div className="flex gap-2">
          <button type="button" onClick={onClose} className="w-1/2 py-2.5 border border-slate-300 text-slate-700 text-xs font-bold rounded-lg hover:bg-slate-50">Batal</button>
          <button type="submit" disabled={loading} className="w-1/2 py-2.5 bg-teal-600 hover:bg-teal-700 text-white text-xs font-bold rounded-lg shadow disabled:opacity-60" data-testid="login-submit-btn">
            {loading ? "Memeriksa..." : "Masuk"}
          </button>
        </div>
      </form>
    </div>
  );
};
